import { useEffect, useState } from 'react';

export default function HomeIntro() {
  const [visible, setVisible] = useState(() => !window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dismiss = () => { if (preference.matches) setVisible(false); };
    const timer = window.setTimeout(() => setVisible(false), 1150);
    preference.addEventListener('change', dismiss);
    return () => { window.clearTimeout(timer); preference.removeEventListener('change', dismiss); };
  }, []);
  if (!visible) return null;
  return <div className="home-intro" aria-hidden="true">
    <img src={`${import.meta.env.BASE_URL}rica-tanto-logo.webp`} alt="" />
    <span className="home-intro-line" />
  </div>;
}
